(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('ExpoStudentsRealController', ExpoStudentsRealController);

    ExpoStudentsRealController.$inject = ['ExpoStudentService', 'ExpoService', 'CitiesByExpoService', 'PhysicalFairService'];


    function ExpoStudentsRealController(ExpoStudentService, ExpoService, CitiesByExpoService, PhysicalFairService) {
        var vm = this;


        vm.flag                  = false;
        vm.expos                 =[];
        vm.expoSelected          =[];
        vm.cities                =[];
        vm.i                     =-1;

        vm.titleCity             ='';
        vm.titleCountry          ='';
        vm.totalStudentsEnrolled ='';

        vm.selectExpo            = selectExpo;
        vm.selectCitiesByExpo    = selectCitiesByExpo;
        vm.getEnrroledInLocation = getEnrroledInLocation;
        vm.getByFilter           = getByFilter;
        vm.citySelected          = [];

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                vm.expos = response.data;
                vm.expos.unshift({id : -1, name : '--- All ---'});
            }).catch(function(err) {

            });
        }

        function selectCitiesByExpo () {
            if (vm.expoSelected.id !== -1) {
                vm.cities               = [];
                vm.citySelected         = [];
                CitiesByExpoService.getCities(vm.expoSelected.id).then(function(response){
                    vm.cities = response.data;
                    vm.cities.unshift({id : -1, city_name : '--- All ---'});
                }).catch(function(err) {

                });
            }
        }
        function getEnrroledInLocation () {
            const data = {};
            data['expo_id'] = vm.expoSelected.id;
            data['expo_location_id'] = vm.citySelected.expos_locations_id;
            ExpoStudentService.getStudentsEnrroledByLocation(data)
            .then(function(response){
                vm.totalStudentsEnrolled = response.data;
            }).catch(function(err) {

            });
        }

        function getByFilter() {
            vm.flag = false;
            const query = {};
            if (vm.expoSelected.id !== -1) {
                query['expo_id'] = vm.expoSelected.id;
                if (vm.citySelected.id !== -1) {
                    query['expo_location_id'] = vm.citySelected.expos_locations_id;
                }
            }
            
            
            ExpoStudentService.getAllStudentsErrolled(query).then(function(response){
                vm.expo = response.data;
                vm.flag = true;

                vm.titleCity = vm.citySelected.city_name;
                vm.titleCountry = vm.expoSelected.name;
            }).catch(function(err){

            });

            vm.flagForViewGraph = true;
        }

        activate();
    }

})();